module.exports = __webpack_public_path__ + "img/wide.452172a3.jpg";